import { Divider } from 'antd';
import { InputFromUser } from '../../components/Input/input';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';

const TreatmentRecommendation = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  setFieldValue,
  IsFilledForm,
  ConsultationMasterData,
}) => {
  return (
    <>
      {/* Treatment Recommendation */}
      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <div className="card-body p-3">
              <div className="mb-3">
                <h4 style={{ color: '#111827', fontWeight: '700', fontSize: '18px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <FeatherIcon icon="shield" size="20" style={{ color: '#4f46e5' }} />
                  Treatment Recommendation
                </h4>
              </div>
              <div className="row">
                {values?.treatment?.map((item, i) => {
                  return (
                    <>
                      <InputFromUser
                        error={errors.treatment?.[i]?.treatmentName}
                        touched={true}
                        placeholder={'Enter Your Treatment'}
                        type="singleSelect"
                        options={
                          (ConsultationMasterData?.treatments &&
                            ConsultationMasterData?.treatments?.map(v => v.name)) ||
                          []
                        }
                        name="treatments"
                        onChange={v => {
                          const newValue = [...values.treatment];
                          newValue[i].treatmentName = v;
                          handleChange({
                            target: {
                              name: 'treatment',
                              value: newValue,
                            },
                          });
                        }}
                        value={values.treatment?.[i].treatmentName}
                        FormGroupClassName={'col-xl-4 col-md-12'}
                        LabelClassName={'col-form-label'}
                        onBlur={undefined}
                        label="Treatment"
                        disabled={IsFilledForm}
                      />
                      <InputFromUser
                        error={errors.treatment?.[i].other}
                        touched={true}
                        placeholder={'Extra Treatments'}
                        type="text"
                        name="treatment"
                        onChange={v => {
                          const newValue = [...values.treatment];
                          newValue[i].other = v.target.value;
                          handleChange({
                            target: {
                              name: 'treatment',
                              value: newValue,
                            },
                          });
                        }}
                        value={values.treatment?.[i].other}
                        FormGroupClassName={'col-xl-4 col-md-12'}
                        LabelClassName={'col-form-label'}
                        onBlur={undefined}
                        label="Extra Treatments"
                        disabled={IsFilledForm}
                      />
                      <InputFromUser
                        error={errors.treatment?.[i].treatmentsDay}
                        touched={true}
                        placeholder={'Enter number of days'}
                        type="number"
                        name="treatment"
                        onChange={e => {
                          const newValue = [...values.treatment];
                          newValue[i].treatmentsDay = e.target.value;
                          handleChange({
                            target: {
                              name: 'treatment',
                              value: newValue,
                            },
                          });
                        }}
                        value={values.treatment?.[i]?.treatmentsDay}
                        FormGroupClassName={'col-xl-4 col-md-12'}
                        LabelClassName={'col-form-label'}
                        onBlur={undefined}
                        label="Days"
                        disabled={IsFilledForm}
                      />
                      <Divider dashed />
                    </>
                  );
                })}
                {/* Treatment Recommendation end */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Solution Recommendation */}
      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <div className="card-body p-3">
              <div className="mb-3">
                <h4 style={{ color: '#111827', fontWeight: '700', fontSize: '18px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <FeatherIcon icon="check-circle" size="20" style={{ color: '#4f46e5' }} />
                  Solution Recommendation
                </h4>
              </div>
              <div className="row">
                {values?.solution?.map((item, i) => {
                  return (
                    <>
                      <InputFromUser
                        error={errors.solution?.[i]?.solutionName}
                        touched={true}
                        placeholder={'Enter Your Detox Programs'}
                        type="singleSelect"
                        options={
                          (ConsultationMasterData?.solution &&
                            ConsultationMasterData?.solution?.map(v => v.name)) ||
                          []
                        }
                        name="treatments"
                        onChange={v => {
                          const newValue = [...values.solution];
                          newValue[i].solutionName = v;
                          handleChange({
                            target: {
                              name: 'solution',
                              value: newValue,
                            },
                          });
                        }}
                        value={values.solution?.[i].solutionName}
                        FormGroupClassName={'col-xl-4 col-md-12'}
                        LabelClassName={'col-form-label'}
                        onBlur={undefined}
                        label="Detox Programs"
                        disabled={IsFilledForm}
                      />
                      <InputFromUser
                        error={errors.solution?.[i].other}
                        touched={true}
                        placeholder={'Extra Treatments'}
                        type="text"
                        name="solution"
                        onChange={v => {
                          const newValue = [...values.solution];
                          newValue[i].other = v.target.value;
                          handleChange({
                            target: {
                              name: 'solution',
                              value: newValue,
                            },
                          });
                        }}
                        value={values.solution?.[i].other}
                        FormGroupClassName={'col-xl-4 col-md-12'}
                        LabelClassName={'col-form-label'}
                        onBlur={undefined}
                        label="Extra Treatments"
                        disabled={IsFilledForm}
                      />
                      <InputFromUser
                        error={errors.solution?.[i].treatmentsDay}
                        touched={true}
                        placeholder={'Enter number of days'}
                        type="number"
                        name="solution"
                        onChange={e => {
                          const newValue = [...values.solution];
                          newValue[i].treatmentsDay = e.target.value;
                          handleChange({
                            target: {
                              name: 'solution',
                              value: newValue,
                            },
                          });
                        }}
                        value={values.solution?.[i]?.treatmentsDay}
                        FormGroupClassName={'col-xl-4 col-md-12'}
                        LabelClassName={'col-form-label'}
                        onBlur={undefined}
                        label="Days"
                        disabled={IsFilledForm}
                      />
                      <Divider dashed />
                    </>
                  );
                })}
              </div>
              {/* Solution Recommendation end */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TreatmentRecommendation;